<template>
  <v-form ref="form2">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Persoonlijke gegevens</span>

      <v-card class="card w-100 d-flex flex-column ga-10" flat>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary">Geslacht</span>
          <v-radio-group class="mt-4" v-model="localQuestions['Geslacht']" :rules="[rules.select_rules.required]">
            <v-radio class="radio-btn-rounded" color="secondary" label="Vrouw" value="vrouw" />
            <v-radio class="radio-btn-rounded" color="secondary" label="Man" value="man" />
          </v-radio-group>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">Geboortedatum</span>

          <v-text-field v-model="localQuestions['Geboortedatum']" :rules="[rules.text_field_rules.required, rules.text_field_rules.isDateFormat,]" 
          color="secondary" base-color="secondary" variant="underlined" placeholder="dd/mm/yy"/>

          <!-- <v-date-input v-model="localQuestions['Geboortedatum']"
            :rules="[rules.text_field_rules.required, rules.text_field_rules.isDateFormat,]" variant="underlined"
            placeholder="dd/mm/yy" color="secondary" base-color="secondary" prepend-icon="" view-mode="year"
            @input="updateDate" /> -->
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">Lengte</span>
          <v-text-field v-model="localQuestions['Lengte']" :rules="[rules.text_field_rules.required]" color="secondary"
            base-color="secondary" variant="underlined">
            <template v-slot:append-inner>
              <div class="">
                <span class="text-normal text-secondary">CM</span>
              </div>
            </template>
          </v-text-field>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">Gewicht</span>
          <v-text-field color="secondary" v-model="localQuestions['Gewicht']" :rules="[rules.text_field_rules.required]"
            base-color="secondary" variant="underlined">
            <!-- placeholder="In kilogram" -->
            <template v-slot:append-inner>
              <div class="">
                <span class="text-normal text-secondary">KG</span>
              </div>
            </template>
          </v-text-field>
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

// import { VDateInput } from 'vuetify/labs/VDateInput'

export default {
  components: {
    // VDateInput,
  },
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localQuestions: { ...this.questions },

      date: null, // Actual selected date
      formattedDate: "", // Formatted date to show in input
      showDatePicker: false, // Controls visibility of date picker

      rules: FormRules.rules,
    };
  },

  methods: {
    nextStep() {
      this.$emit("nextStep", this.geslacht);
    },

    updateDate(value) {
      console.log('value', value);
      // Format the date (you can customize this as needed)
      this.formattedDate = this.formatDate(value);

      if (this.formattedDate == "Invalid Date") {
        return;
      }

      this.localQuestions["Geboortedatum"] = this.formattedDate;
      this.showDatePicker = false; // Close the date picker
    },
    formatDate(date) {
      if (!date) return "";
      const day = String(new Date(date).getDate()).padStart(2, "0");
      const month = String(new Date(date).getMonth() + 1).padStart(2, "0");
      const year = new Date(date).getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
  watch: {
    date(value) {
      this.formattedDate = this.formatDate(value);
    },
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
};
</script>
